import { writable } from 'svelte/store';

// Authentication store
export const isAuthenticated = writable(false);

// User store
export const user = writable(null);

// User role store
export const userRole = writable('user');

// Alert store for application notifications
export const alert = writable({
  show: false,
  type: '', // success, error, warning
  message: ''
});

// Show alert helper function
export function showAlert(type, message, duration = 5000) {
  alert.update(() => ({
    show: true,
    type,
    message
  }));
  
  // Automatically hide after duration
  setTimeout(() => {
    alert.update(() => ({
      show: false,
      type: '',
      message: ''
    }));
  }, duration);
}
